import React, { useEffect, useState } from 'react';
import { Modal, ModalBody, ModalHeader, Spinner } from 'reactstrap';
import cogoToast from 'cogo-toast';
import WizardLayout from '../../components/auth/wizard/WizardLayout';
import PersonForm from '../../components/GestionPersonaEmpresa/PersonForm';
import PersonDetails from '../../components/GestionPersonaEmpresa/PersonDetails';
import { authSesion } from '../../helpers/authSesion';
import { normalizeReqBody } from '../../helpers/normalizers';
import { personsServices } from '../../services';

// Rol que el buscador de la solicitud usa para listar clientes (roles '1')
const ROL_CLIENTE = [{ Propiedad: 'Cliente', IdPropiedad: 1 }];

// Consultado por id, el tercero trae los "info*" como "<código>|<nombre>"; el buscador de la
// solicitud los trae con el nombre solo, y la pantalla y el formato impreso los usan así.
const comoBuscador = tercero => {
  const limpiar = seccion => Object.fromEntries(Object.entries(seccion || {}).map(([k, v]) =>
    [k, k.startsWith('info') && typeof v === 'string' && v.includes('|') ? v.split('|')[1] : v]));
  return {
    ...tercero,
    terceroInformacion: limpiar(tercero.terceroInformacion),
    terceroUbicacion: limpiar(tercero.terceroUbicacion),
  };
};

// Permite crear el cliente desde la solicitud, o corregir sus datos, sin tener el módulo de
// Terceros: reutiliza el mismo formulario y el mismo detalle de ese módulo.
const ClientFormModal = ({ open, mode, clientId, cedula, toggle, onSaved }) => {
  const [detalle, setDetalle] = useState();

  const cargar = async id => {
    const resp = await personsServices.getById(id);
    if (!resp || resp.error || !resp.objResponse || !resp.objResponse[0]) {
      cogoToast.error(resp?.msg || 'No se pudo cargar el cliente', { position: 'bottom-right', heading: 'Error' });
      return null;
    }
    return resp.objResponse[0];
  };

  useEffect(() => {
    if (!open || mode !== 'editar' || !clientId) return;
    setDetalle(null);
    cargar(clientId).then(setDetalle);
  }, [open, mode, clientId]);

  const crear = async formData => {
    const reqBody = normalizeReqBody(formData, authSesion(), true);
    const resp = await personsServices.add(reqBody);
    if (!resp || resp.error) {
      cogoToast.error(resp?.msg || 'No se pudo crear el cliente', { position: 'bottom-right', heading: 'Error en la respuesta' });
      return;
    }
    cogoToast.success('El cliente fue creado correctamente', { position: 'bottom-right', heading: 'Agregado' });
    const creado = await cargar(resp.objResponse.id);
    if (creado) onSaved(comoBuscador(creado));
    toggle();
  };

  // PersonDetails avisa "Cargar" al guardar una sección y "Cancelar" con el botón Atrás
  const onAccionDetalle = async accion => {
    if (accion !== 'Cargar') {
      toggle();
      return;
    }
    const actualizado = await cargar(clientId);
    if (actualizado) {
      setDetalle(actualizado);
      onSaved(comoBuscador(actualizado));
    }
  };

  return (
    <Modal isOpen={open} size="xl" toggle={toggle}>
      <ModalHeader toggle={toggle}>
        {mode === 'editar' ? 'Corregir datos del cliente' : 'Crear cliente'}
      </ModalHeader>
      <ModalBody>
        {mode === 'editar' ? (
          detalle
            ? <PersonDetails selected={detalle} handleAction={onAccionDetalle} ocultarRoles />
            : <div className="text-center py-4"><Spinner color="primary" /></div>
        ) : (
          // si lo buscado era un número, se asume cédula y llega escrita en el paso 1
          <WizardLayout initialUser={cedula ? { SelectTipoDocumento: 'CC', NumeroIdentificacion: cedula } : undefined}>
            <PersonForm handleSubmitForm={crear} propiedadesIniciales={ROL_CLIENTE} />
          </WizardLayout>
        )}
      </ModalBody>
    </Modal>
  );
};

export default ClientFormModal;
